import axios from "axios";
import axiosInstance from "../../../Utils/axios";
import { paginationQueryParams } from "../../../Utils/paginationParam";
let cancelToken;

//obtaining the paginated data
export const checkDocRule = () => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`api/v1/core-app/base-document-rules/list`, {
    cancelToken: cancelToken.token,
  });
};

export const getChargeStatus = (type) =>
  axiosInstance.get(`api/v1/core-app/additional-charge-status/list?transaction_type=${type}&is_active=true`);
